export enum OneClickOrigin {
    CALCULADORA = 3
}
export enum OriginPayment {
    INT = 2
}
export enum SourceShoppingCart {
    NEW_CART = 4,
    CART_V3 = 5
}

export enum methodsName {
    PAYPAL = 'paypal',
    DINERO_MAIL = 'dinero_mail',
    CARD = 'tarjeta',
    CASH = 'efectivo',
    TRANSFER = 'transferencia',
    CARD_3DS = 'card_3ds',
}

export const payment_method: any = {
    [methodsName.PAYPAL]: 1,  
    [methodsName.DINERO_MAIL]: 2,
    [methodsName.CARD]: 3,
    [methodsName.TRANSFER]: 4,
    [methodsName.CARD_3DS]: 5,
    [methodsName.CASH]: 6,
};

export const pyament_method_str = {
    [methodsName.PAYPAL]: "Paypal",  
    [methodsName.DINERO_MAIL]: "Dinero Mail",
    [methodsName.CARD]: "Tarjeta",
    [methodsName.TRANSFER]: "Transferencia Bancaria",
    [methodsName.CARD_3DS]: "Tarjeta 3DS",
    [methodsName.CASH]: "Pago en Tienda", 
}
